import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSnowflake = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.6612 3V8.75M11.6612 8.75L9.1711 10.1875M11.6612 8.75L14.1514 10.1875M14.5362 4.15L11.6612 6.45L8.78623 4.15M4.1916 7.3125L9.1711 10.1875M9.1711 10.1875V13.0625M6.625 5.39736L7.1793 9.0375L3.75 10.3776M4.1916 15.9375L9.1711 13.0625M9.1711 13.0625L11.6612 14.5M3.75 12.8724L7.1793 14.2125L6.625 17.8526M11.6612 20.25V14.5M11.6612 14.5L14.1514 13.0625M8.78623 19.1L11.6612 16.8L14.5362 19.1M19.1309 15.9375L14.1514 13.0625M14.1514 13.0625V10.1875M16.6975 17.8526L16.1432 14.2125L19.5725 12.8724M19.1309 7.3125L14.1514 10.1875M19.5725 10.3776L16.1432 9.0375L16.6975 5.39736",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.6612 8.75L9.1711 10.1875V13.0625L11.6612 14.5L14.1514 13.0625V10.1875L11.6612 8.75Z",
		fill: "currentColor"
	})]
});
export { SvgSnowflake as ReactComponent };
